import { PencilIcon } from '@braskai/icons';
import { Typography } from '@braskai/ui-kit';

import { Box, Stack } from '@mui/material';

import { useInterfaceLanguage } from '@/shared/i18n';

import { PaymentMethodIcon } from './PaymentMethodIcon';

type PaymentMethodCardProps = {
  brand?: string;
  isError?: boolean;
  paymentMethod?: string;
  typeName?: string;
  onEdit?: () => void;
};

export const PaymentMethodCard = ({ brand, isError, paymentMethod, typeName, onEdit }: PaymentMethodCardProps) => {
  const { t } = useInterfaceLanguage();
  return (
    <Box
      sx={{
        alignItems: 'center',
        border: '1px solid',
        borderColor: isError ? '#FECDCA' : 'grey.200',
        borderRadius: '8px',
        cursor: onEdit ? 'pointer' : 'default',
        display: 'flex',
        gap: '8px',
        justifyContent: 'space-between',
        padding: isError ? '12px 16px' : '16px',
      }}
      data-testid="payment-method-card-edit"
      onClick={onEdit}
    >
      {isError ? (
        <>
          <Typography sx={{ color: '#B42318' }} variant="body-2-md">
            {t('billing.confirm.updatePayment')}
          </Typography>
          <PencilIcon color="#B42318" height={16} width={16} />
        </>
      ) : (
        <>
          <Typography color="grey.900" variant="body-2-md">
            {t('billing.confirm.paymentMethod')}
          </Typography>
          <Stack alignItems="center" direction="row" gap={8} sx={{ flex: 1, justifyContent: 'flex-end' }}>
            {paymentMethod && (
              <Typography color="grey.500" variant="body-2">
                {paymentMethod}
              </Typography>
            )}
            <PaymentMethodIcon brand={brand} type={typeName} />
          </Stack>
          <PencilIcon color="#667085" height={16} width={16} />
        </>
      )}
    </Box>
  );
};
